import { render, staticRenderFns } from "./frontMiPerfilContainer.vue?vue&type=template&id=37aa933e&scoped=true&"
import script from "./frontMiPerfilContainer.vue?vue&type=script&lang=js&"
export * from "./frontMiPerfilContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa933e",
  null
  
)

export default component.exports